"use client";

import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function StartYourAscent() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const contactDetails = [{
    icon: Mail,
    label: "Direct Inquiries",
    value: "hello@lanaconnect.com",
    href: "mailto:hello@lanaconnect.com"
  }, {
    icon: Phone,
    label: "Call Our Experts",
    value: "(800) 555-LANA",
    href: "tel:+18005555262"
  }, {
    icon: MapPin,
    label: "Headquarters",
    value: "Fintech Plaza, Suite 400",
    href: "https://maps.google.com/?q=Fintech+Plaza"
  }];
  return <section data-section-id="17230" id="reach-our-experts" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {}
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-7xl font-bold tracking-tighter leading-[1.1] text-primary">
              Experts,
              <br />
              <span className="text-ring font-serif italic">One Connection.</span>
            </h1>
          </div>

          {}
          <div className="flex flex-col gap-8 lg:pl-12 border-l border-border/30 lg:border-l-0">
            {contactDetails.map((item, i) => <div key={i} data-index={i} className="group flex items-start gap-5">
                <div className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/5 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground shadow-sm">
                  <item.icon className="h-5 w-5" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-muted-foreground mb-1 tracking-wide uppercase">
                    {item.label}
                  </span>
                  <Link to={item.href} className="text-xl md:text-2xl font-medium text-secondary hover:text-ring transition-colors duration-300">
                    {item.value}
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {}
      <div className="absolute top-0 right-0 -z-10 h-full w-1/2 opacity-5 pointer-events-none bg-[radial-gradient(circle_at_center,_var(--border)_1px,_transparent_1px)] [background-size:40px_40px]" />
    </section>;
}